class exports.View_User_Dialog extends DialogHandler
    constructor: () ->
        super()
        @amountOfInfo = 'small'

    init: () ->
        @classes = 'medium_dialog'
        if @amountOfInfo is 'small'
            @layoutUrl = 'backend/grower/contacts/viewusers'
        else
            @layoutUrl = 'backend/grower/contacts/viewuser'
        @refreshNavHandler = false

        @createDialog()

    afterLoadLayout: () ->
        ths = this

        @openDialog()
